import { kindLabel, originLabel } from "@/lib/impactNodes";

const KIND_STYLE = {
  program: { bg: "#f4f4f4", fg: "#393939", border: "#8d8d8d" },
  file: { bg: "#edf5ff", fg: "#0043ce", border: "#78a9ff" },
  logical_file: { bg: "#edf5ff", fg: "#0043ce", border: "#78a9ff" },
  field: { bg: "#f6f2ff", fg: "#6929c4", border: "#be95ff" },
  unknown: { bg: "#ffffff", fg: "#6f6f6f", border: "#c6c6c6" },
};

/** Iter 43 — plain kind label ("Program" / "File" / "Field" / "Unknown") + "Parsed source" tag. */
export default function ImpactKindTag({ node, testid }) {
  const kind = node?.kind || "unknown";
  const s = KIND_STYLE[kind] || KIND_STYLE.unknown;
  const origin = originLabel(node?.origin);
  const objectType = kind === "unknown" && node?.object_type ? node.object_type : null;
  return (
    <span className="inline-flex items-center gap-1 shrink-0" data-testid={testid} data-kind={kind} data-origin={node?.origin || "unknown"}>
      <span
        className="ml-mono text-[10px] uppercase tracking-widest px-1.5 py-0.5 border whitespace-nowrap"
        style={{ background: s.bg, color: s.fg, borderColor: s.border, borderStyle: kind === "unknown" ? "dashed" : "solid" }}
      >
        {kindLabel(kind)}{objectType ? ` · ${objectType}` : ""}
      </span>
      {origin && (
        <span
          className="ml-mono text-[10px] uppercase tracking-widest px-1.5 py-0.5 border border-dashed whitespace-nowrap"
          style={{ background: "#fff8e1", color: "#8a6d00", borderColor: "#d2a106" }}
          title={node?.origin === "parsed"
            ? "Known from parsed RPG / CL / DDS source — no DSPOBJD / DSPFD catalog row"
            : "Known only from DSPPGMREF reference rows — object not in the DSPOBJD / DSPFD catalog"}
        >
          {origin}
        </span>
      )}
    </span>
  );
}
